import HTTP from '../httpRouter';

const OPPORTUNITE_URL = 'PortailAnnonceur/';

export async function getDetailOpportunite(id) {
  const response = await HTTP.get(OPPORTUNITE_URL, { params: { hash: id } });
  return response;
}

export async function getOpportunitePdf(id) {
  const response = await HTTP.get(OPPORTUNITE_URL + 'action/pdf/',
    { responseType: 'blob', params: { hash: id } });
  return response;
}

export async function sendEmail(id, body) {
  const response = await HTTP.post(OPPORTUNITE_URL + 'mail/?hash=' + id, body);
  return response;
}



// WEBPACK FOOTER //
// ./src/api/opportunite/index.js